import backend from '../index'

export default async function getCostCenters() {
  const costCenters = await backend.get(`/finance/cost-centers`)
  return costCenters.data
}
